import React from "react";
import { Box, Container } from "@mui/system";
import { Button, Divider, List, ListItem, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function Layout2Section5({ acf }) {
  // console.log("Layout2Section5", acf);

  const navigate = useNavigate();

  const btnStyle = {
    border: "1px solid #FFF",
    color: "#fff",
    borderRadius: "2rem",
    fontSize: "1rem",
    p: "0.5rem 1.5rem",
    mr: "1rem",
    mb: ".35rem",
  };

  return (
    <Box
      sx={{
        position: "relative",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          color: "#fff",
          transform: "translateZ(1px)",
          background: acf?.background_color ? acf.background_color : "#dddddd",
          pt: 10,
          pb: 10,
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
            },
          }}
        >
          {acf?.heading && acf?.heading !== "" ? (
            <Typography
              variant="h2"
              component="h2"
              sx={{
                textAlign: "left",
                fontWeight: 600,
                mb: 2,
              }}
            >
              {acf.heading}
            </Typography>
          ) : null}

          {acf?.bullet_points && acf?.bullet_points.length > 0 ? (
            <List
              sx={{
                width: "100%",
                marginTop: "20px",
              }}
            >
              {acf.bullet_points.map((bullet_point, index) => (
                <ListItem
                  key={index}
                  sx={{
                    display: "flex",
                    pl: 0,
                    "&:before": {
                      display: "none",
                    },
                  }}
                >
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    size="xl"
                    style={{
                      color: "#fff",
                      marginRight: "10px",
                    }}
                  />
                  <Typography key={index}>
                    {bullet_point.bullet_point}
                  </Typography>
                </ListItem>
              ))}
            </List>
          ) : null}

          {acf?.description && acf?.description !== "" ? (
            <Typography
              variant="p"
              component="p"
              sx={{
                // fontSize: "1.2rem",
                mt: "1rem",
                fontWeight: 500,
              }}
            >
              {acf.description}
            </Typography>
          ) : null}

          <Divider
            sx={{
              width: "100%",
              backgroundColor: "#fff",
              mt: 4,
              mb: 4,
            }}
          />

          {acf?.call_to_action?.heading &&
          acf?.call_to_action?.heading !== "" ? (
            <Typography
              variant="h2"
              component="h2"
              sx={{
                textAlign: "left",
                fontWeight: 600,
                mb: 2,
              }}
            >
              {acf.call_to_action.heading}
            </Typography>
          ) : null}

          {acf?.call_to_action?.description &&
          acf?.call_to_action?.description !== "" ? (
            <Typography
              variant="p"
              component="p"
              sx={{
                // fontSize: "1.2rem",
                fontWeight: 500,
                mb: 2,
              }}
            >
              {acf.call_to_action.description}
            </Typography>
          ) : null}

          {acf?.call_to_action?.links && acf?.call_to_action?.links.length > 0
            ? acf.call_to_action.links.map((link, index) => (
                <Button
                  sx={btnStyle}
                  onClick={() => {
                    console.log(link);
                    window.location = link.link;
                  }}
                >
                  {link.label}
                </Button>
              ))
            : null}
        </Box>
      </Container>
    </Box>
  );
}
